import { ReactNode } from 'react';

interface IfProps {
  condition: boolean;
  children: ReactNode;
}

function If({ condition, children }: IfProps) {
  return condition ? children : null;
}

export default If;
